import request from '@/libs/request';

export const saveDrafts = (data = {}) => request('saveDraft', data);
export const selectOptions = (data = {}) => request('selectOption', data);
export const getDrafts = (data = {}) => request('getDraft', data);
export const registerEnterprises = (data = {}) => request('registerEnterprise', data);
export const getEnterpriseByManagers = (data = {}) => request('getEnterpriseByManager', data);
